import { Injectable } from '@angular/core';
import { eventSourceEnabled } from 'environments/environment';
import { preferencesLinkEnabled } from 'environments/environment';
import { previewCaptureEnabled } from 'environments/environment';

@Injectable({ providedIn: 'root' })
export class FeaturesService {

  public get eventSourceEnabled(): boolean {
    return eventSourceEnabled;
  }

  public get preferencesLinkEnabled(): boolean {
    return preferencesLinkEnabled;
  }

  public get previewCaptureEnabled(): boolean {
    return previewCaptureEnabled;
  }

}
